import { message } from "antd";
import store from "store2";
import {
  getFormInfo,
  getGenerateCode,
  getRouteInfo,
  getUserList,
  updateForm
} from "../services/formConfig";
import { getConditions, getWidgetInfo } from "../utils/formConfig";
import { enableFlow } from "../services/flowConfig";

// 设置加载属性
const setSpinProps = ({ put, spinning = false, tip = "" }) => {
  return put({
    type: "save",
    payload: {
      spinProps: {
        spinning,
        tip
      }
    }
  });
};

const initState = () => {
  return {
    templateList: [],
    /**
     * 中间已配置控件列表数据
     * active: true  --是否为选中状态
     * code: "mobile-select"  --控件编码
     * conditions: (5) [{…}, {…}, {…}, {…}, {…}] --右侧字段属性
     * group: "base"  --分组类型
     * id: "340000201304176590"  --控件模板id
     * image: "http://dummyimage.com/121"--控件图标
     * name: "单行文本"  --控件名称
     * widgetCode: "widgetCodebJCAwruKe7bZ2UfcvBb  --控件实例唯一标识，由前端生成
     */
    widgetList: [],
    formInfo: {
      programId: null, // 应用Id(修改时必填)
      formId: null, // 表单id,
      organization: 1, //  选人组件类型(1学校,2教育局)
      status: 0, // 表单状态，默认为0，0： 草稿，1： 启用中
      name: "未命名表单", // 表单名字
      imgLogo:
        "https://zj-education.oss-cn-hangzhou.aliyuncs.com/work-flow-img/home_bg.svg" // 表单头像
    },
    activeId: null, // form配置中选中id，用于控件配合属性时获取属性列表
    activeItem: {}, // 选中的数据
    subActiveItem: {}, // 子表明细选中的数据
    isSave: true, // 表单是否保存数据
    // 加载状态
    spinProps: {
      spinning: false,
      tip: "加载中..."
    },
    formDisabled: false, // 表单是否可以编辑
    formTitleDisabled: false // 表单标题是否可编辑
  };
};

export default {
  namespace: "workflowFormConfig",

  state: initState(),

  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname, query }) => {
        if (pathname.match(/^.+\/form[Cc]onfig$/)) {
          const { disabled, formTitleDisabled } = query;
          // 先更新formInfo，否则请求时，会展示默认图片
          dispatch({
            type: "save",
            payload: {
              isSave: true,
              formInfo: {
                ...initState().formInfo,
                ...query,
                formType: +query.formType
              },
              formDisabled: disabled === "true",
              formTitleDisabled: formTitleDisabled === "true"
            }
          });
          dispatch({
            type: "fetchTemplateList",
            payload: { query }
          });
          // 获取用户信息，判断使用选人组件版本
          dispatch({
            type: "fetchRoute",
            payload: {}
          });
        }
      });
    }
  },

  effects: {
    *fetchTemplateList({ payload }, { call, select, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const { formInfo: preFormInfo } = yield select(
          state => state.workflowFormConfig
        );
        const { programId, formId } = preFormInfo;

        const { templates, widgets, ...formInfo } = yield call(getFormInfo, {
          programId,
          formId,
          ...payload.query
        });

        yield put({
          type: "save",
          payload: {
            isSave: true,
            templateList: templates || initState().templateList,
            widgetList: widgets || initState().widgetList,
            formInfo: {
              ...preFormInfo,
              ...formInfo,
              appId: formInfo.appId || preFormInfo.appId,
              formType: formInfo.formType || preFormInfo.formType
            },
            spinProps: {
              spinning: false
            }
          }
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchRoute(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const userInfo = yield call(getRouteInfo);
        store.session("workFlow_userInfo", userInfo);

        yield setSpinProps({ put });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *getGenerateCode(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const code = yield call(getGenerateCode);

        yield setSpinProps({ put });

        return Promise.resolve(code);
      } catch (error) {
        yield setSpinProps({ put });
        return Promise.reject();
      }
    },

    // 属性设置-可选范围  根据selectId获取选人组件具体用户列表
    *fetchUserList({ payload }, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });
        const { widgetList, activeId, ...params } = payload;

        const response = yield call(getUserList, params);
        const { selectId } = payload;

        const { widgetList: parentWidgetList } = yield select(
          state => state.workflowFormConfig
        );

        const {
          currentUser: { orgId: currentOrgId }
        } = yield select(state => state.user);

        // 获取选中的组件
        const widgetInfo = getWidgetInfo({ activeId, widgetList });

        // 更新ui控件中的下拉列表，以及选中项
        widgetInfo.values = response.map(item => ({
          code: item.userId,
          name: item.userName,
          orgId: item.orgId || currentOrgId,
          orgName: item.orgName
        }));
        widgetInfo.defaultValue = null;

        // 获取可选范围配置项
        const optionsLimit = getConditions({
          conditionsList: widgetInfo.conditions || [],
          widgetName: "optionsLimit"
        });

        // 获取默认值配置项
        // const defaultValue = getConditions({
        //   conditionsList: widgetInfo.conditions || [],
        //   widgetName: "defaultValue"
        // });
        // 将可选范围中的选人信息同步到可选范围配置项中
        optionsLimit.conditionUser = {
          selectId,
          conditionUsers: response.map(item => ({ ...item }))
        };
        // 保存给后端需要将selectId和列表conditionUsers放在外边一层
        optionsLimit.selectId = selectId;
        optionsLimit.conditionUsers = response;

        // if (defaultValue) {
        //   // 将可选范围中的选人信息同步到默认值配置项中
        //   defaultValue.conditionUser = {
        //     selectId,
        //     conditionUsers: response.map(item => ({ ...item }))
        //   };
        //   // 保存给后端需要将selectId和列表conditionUsers放在外边一层
        //   defaultValue.selectId = selectId;
        //   defaultValue.conditionUsers = response;
        // }

        console.log("parentWidgetList", parentWidgetList);

        // 渲染中间控件列表
        yield put({
          type: "save",
          payload: {
            widgetList: [...parentWidgetList],
            spinProps: {
              spinning: false
            }
          }
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchSubmit({ callback }, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const { widgetList, formInfo } = yield select(
          state => state.workflowFormConfig
        );
        const { formId } = formInfo;

        // 前端校验错误信息
        let hasError = false;
        let errorMsg = "";

        // 滑动至第一个报错组件处
        let errorWidget = null;

        widgetList.forEach(widgetItem => {
          const { conditions, code: typeCode, sublist, title } = widgetItem;
          if (
            typeCode === "mobile-sublist" &&
            (!sublist || sublist.length === 0)
          ) {
            errorMsg = `[${title}] 请添加子字段`;
            hasError = true;
            return;
          }
          conditions.forEach(condition => {
            const { attribute, conditionValues } = condition;
            if (attribute === "rule") {
              conditionValues.forEach(conditionValue => {
                const { code, defaulted, value } = conditionValue;
                if (code === "precision") {
                  if (value === "" && defaulted === 1) {
                    // eslint-disable-next-line
                    conditionValue.defaulted = 0;
                  } else if (defaulted === 0) {
                    // eslint-disable-next-line
                    conditionValue.value = "";
                  }
                } else if (code === "scopeLimit") {
                  const valArr = value.split(",");
                  if (
                    valArr.length === 2 &&
                    parseFloat(valArr[0]) > parseFloat(valArr[1]) &&
                    defaulted === 1
                  ) {
                    // eslint-disable-next-line
                    conditionValue.isError = true;
                    // eslint-disable-next-line
                    widgetItem.isError = true;
                    hasError = true;
                    errorMsg = "限定范围：最大值应大于等于最小值";
                    if (!errorWidget) {
                      errorWidget = widgetItem;
                    }
                  } else if (
                    (value === "," || value === "") &&
                    defaulted === 1
                  ) {
                    // eslint-disable-next-line
                    conditionValue.defaulted = 0;
                  } else if (defaulted === 0) {
                    // eslint-disable-next-line
                    conditionValue.value = "";
                  }
                }
              });
            }
          });
        });

        if (hasError) {
          yield put({
            type: "save",
            payload: {
              isSave: true,
              widgetList: [...widgetList],
              // activeId: errorWidget.widgetCode,
              // widgetItem: errorWidget,
              spinProps: {
                spinning: false
              }
            }
          });

          message.warning(errorMsg);
          yield setSpinProps({ put });

          return;
        }

        const response = yield call(updateForm, {
          ...formInfo,
          action: formId ? 2 : 1, // 操作标志：1新增，2修改
          widgets: widgetList
        });

        yield put({
          type: "save",
          payload: {
            isSave: true,
            formInfo: {
              ...formInfo,
              ...response,
              appId: formInfo.appId || response.appId
            },
            spinProps: {
              spinning: false
            }
          }
        });

        message.success("保存成功");

        if (callback && typeof callback === "function") {
          callback(response); // 返回结果
        }
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchEnable(_, { call, put, select }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: "加载中..." });

        const { formInfo } = yield select(state => state.workflowFormConfig);

        yield call(enableFlow, {
          programId: formInfo.programId,
          appInstanceId: formInfo.appInstanceId,
          formType: 2
        });

        message.success("启用成功");

        yield put({
          type: "saveNoDataChange",
          payload: {
            formInfo: {
              ...formInfo,
              status: 1 // 启用中状态
            },
            spinProps: {
              spinning: false
            }
          }
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *scrollIntoView(_, { select }) {
      const { widgetList, activeId } = yield select(
        state => state.workflowFormConfig
      );
      const selectedWidget = getWidgetInfo({
        widgetList,
        activeId // 默认滑动至选中控件处
      });
      if (selectedWidget.ref) {
        selectedWidget.ref.scrollToTop();
      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        isSave: false,
        ...payload
      };
    },
    saveNoDataChange(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    reset() {
      return { ...initState() };
    }
  }
};
